
import XInput from 'vux/src/components/x-input/index.vue'
import Countdown from 'vux/src/components/countdown/index.vue'

import { getChatStat, getJSSDK } from "../../api/api";
import { STORAGE_KEY } from "../../utils/define";
import { utils } from "../../S51WebGLSDK/utils/utils";
import PaymentModel from "../PaymentModel/PaymentModel.vue";
import { uploadQiniu } from "../../qiniu";
import "./Loading.less";
import { BUS_EVENT, EventBus } from "../../eventBus";
let recorder = null;
const TIME_COUNT = 60;
export default {
name: "ChatInput",
components: {
XInput,
Countdown,
PaymentModel,
},
props: {
disabled: Boolean,
voiceShowIs: Number,
isChatGPT: Boolean,
isMyself: Boolean,
preinstallListIs: Array,
packUnfoldBloIs: Boolean,
packUnfoldStateIs: Boolean,
hasConsume: Boolean,
packUnfoldShow: Number,
voiceContentListIs: Array,
companyID:Number,
},
data() {
return {
activeDisabled: this.disabled,
cutRecordState: false,
myChatVoiceBlob: undefined,
value: "",
time: TIME_COUNT,
show: false,
countHandler: undefined,
isActiveChatGPT: this.isChatGPT,
isActiveMyself: this.isMyself,
isHasConsume: this.hasConsume || false,
inputType: true,
preinstallList: this.preinstallListIs || [],
packUnfoldBlo: this.packUnfoldBloIs,
packUnfoldState: this.packUnfoldStateIs,
typeShow: this.packUnfoldShow,
touchCancel: false,
voiceContentList: this.voiceContentListIs,
hasNotPermission: true,
activeEnableInput:true,
};
},
mounted() {
console.log("ChatInput mouted 111", window.location);
if (this.$refs.messageInput.$el.getElementsByTagName("input").length > 0) {

this.$refs.messageInput.$el.getElementsByTagName(
"input"
)[0].enterKeyHint = "send";
}

if (this.isMyself) {
getChatStat().then((res) => {
if (res.data.char_num_use > 0) this.isHasConsume = true;
else this.isHasConsume = false;
console.log("is isMyself", this.isHasConsume);
});
}
EventBus.$on(BUS_EVENT.ENABLE_INPUT, param => {
console.log('收到 enable input  消息',param)
this.activeEnableInput = param.enable
})

},
created() {

},
beforeDestroy() { },
methods: {
onPackUnfold() {
this.$emit("onPackUnfold")
},
onGotoConsumeRecord() {
console.log("跳转消耗明细");
this.$wechat.miniProgram.navigateTo({
url: "/walletPage/pages/chatConsumeRecord/chatConsumeRecord",
success: function () {
console.log("跳转成功");
},
});
},
onOpenChargeModel() {
console.log("----充值购买");
this.$emit("onOpenChargeModel");
},


onTouchstart(e) {
console.log("ontouch start");

if (this.activeDisabled) {
return;
}
e.preventDefault();

if(this.cutRecordState){//正在录音
return;
}
if(this.startRecord>0 && Date.now() - this.startRecord<500){
return
}
this.touchCancel = false
this.touchStop=false
this.cutRecordState = true;

this.startRecord = Date.now()
let self=this
window.MyRecorder.get(
(res, err) => {
self.$refs.voiceInputBtn.focus()
document.dispatchEvent(new MouseEvent('click', {
bubbles: true,
cancelable: true,
view: window,
clientX: 1, // 鼠标点击位置的x坐标
clientY: 1 
}))

if (err) {
console.error(err)
self.cutRecordState=false;
return self.$vux.toast.show({
type: 'text',
text: '获取录音权限失败'
})
}

setTimeout(()=>{

if (self.touchCancel || self.touchStop) {//超过300毫秒认为用户点击了授权
return self.cutRecordState=false;
}
recorder = res;
self.time = TIME_COUNT;
self.show = true;
self.$emit("onInputStartRecordAudio", true);
recorder.start();

if (self.countHandler) clearInterval(self.countHandler);
self.countHandler = setInterval(() => {
if (self.time >= 1) {
self.time--;
}
if (self.time <= 0) {
self.stopRecord();
}
}, 1000);
console.log("%c⧭", "color: #1d5673", res);
},300)


},
null, self
);


},

onTouchmove(e) {
console.log("%c⧭", "color: #00bf00", e);
},
resetRecord(){

window.MyRecorder.reset() 

},
stopRecord(){
let self = this
self.time = 0;
self.show = false;
self.cutRecordState = false;
if (self.countHandler) clearInterval(self.countHandler);

if(recorder){
recorder.stop((src,option)=>{
console.log("main ========================================= ", option);

if (option.duration < 1) {
self.resetRecord()
return self.$vux.toast.show({
type: 'text',
text: '说话时间太短'
})
}
if(self.touchCancel){
self.resetRecord()
return
}
if (self.myChatVoiceBlob) {
delete self.myChatVoiceBlob;
self.myChatVoiceBlob = undefined;
}
self.myChatVoiceBlob = window.URL.createObjectURL(src);

var a = new FileReader();
a.readAsDataURL(src); 
a.onload = function (e) {
var getRes = e.target.result;

let file = new File([recorder.saveAsWavFile(getRes)], 'chataudio.wav', { type: 'audio/wav' })
self.$vux.loading.show({
text: '正在发送...'
})
uploadQiniu(file, 'wav', (process)=>{
console.log(process)
}, (err, res) => {
self.$vux.loading.hide()
if(err){
return self.$vux.toast.show({
type: 'text',
text: '音频发送失败'
})
}
self.$emit("onInputEndRecordAudio", {
voiceUrl: self.myChatVoiceBlob, //voice url数据，可用于播放
voiceSendData: res.key, //voice base64数据，用于聊天发送
voiceHttpUrl:res.domain+res.key,
duration: option.duration
});
})

};
self.resetRecord()
})
}
else{
this.resetRecord()
}
},
onTouchCancel(e) {
console.log('被取消')

this.touchCancel = true
this.stopRecord()
},

onTouchend(e) {
this.touchStop=true
this.stopRecord()

},

onSend() {
if (this.activeDisabled) {
return;
}
if (!this.value || this.value.length == 0) {
return;
}
this.$emit("onInputWordSend", this.value);
setTimeout(() => {
this.$refs.messageInput.blur();
}, 200); //延时200毫秒失去焦点
this.value = "";
if (this.myChatVoiceBlob) {

delete this.myChatVoiceBlob;
this.myChatVoiceBlob = undefined;
}
},
sendComment(e) {
this.onSend();
},
inputClick() {
this.$refs.messageInput.focus();
},
finish(index) {
this.onTouchend();

console.log("current index", index);
},
upChat() {
console.log('升级chatgpt')
this.$emit("onUpChat")
},
sendPreQuestion(item) {
if(!this.activeEnableInput){
return
}
this.$emit("onSendPreQuestion", item)
}
},
watch: {
disabled(val) {

console.log('%c⧭', 'color: #99adcc', val)
this.activeDisabled = val;
},
voiceContentListIs(value) {
this.voiceContentList = value;
},
isChatGPT(val) {
console.log("is chat gpt", val);
this.isActiveChatGPT = val;
},
packUnfoldShow(value) {
this.typeShow = value;

console.log('%c⧭', 'color: #408059;font-size:90px', value)
},
preinstallList(value) {

console.log('%c⧭', 'color: #ffcc00;font-size:90px', value)
},
isMyself(val) {
console.log('---ChatInput mouted')
this.isActiveMyself = val;
if (this.isMyself) {
getChatStat().then((res) => {
if (res.data.char_num_use > 0) this.isHasConsume = true;
else this.isHasConsume = false;
console.log("is isMyself", this.isHasConsume);
});
}
},
packUnfoldBloIs(value) {
this.packUnfoldBlo = value;
},
packUnfoldStateIs(value) {
this.packUnfoldState = value;
},
hasConsume(val) {
this.isHasConsume = val
},
preinstallListIs(val) {
this.preinstallList = val
}

},
};



// WEBPACK FOOTER //
// ./src/myComponents/ChatInput/ChatInput.vue